import "./ClubPlanListPage.scss";

import { Col, Row } from "react-bootstrap";
import React, { useEffect, useState } from "react";
import { faAdd, faGem } from "@fortawesome/free-solid-svg-icons";

import AppLoading from "../../../../../commons/AppLoading";
import ClubPlanAPI from "../../api/ClubPlanAPI";
import ClubPlanCard from "../../components/ClubPlanCard";
import ClubSubscriptionAPI from "../../api/ClubSubscriptionAPI";
import EmptyState from "../../../../../commons/EmptyState";
import FloatingButton from "../../../../../commons/buttons/FloatingButton";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import HallAppToast from "../../../../../commons/HallAppToast";
import MenuTitle from "../../../../../commons/menu/MenuTitle";
import ModalClubConfiguration from "../../components/ModalClubConfiguration";
import ModalSelectCustomers from "../../../../../commons/modal/ModalSelectCustomers";
import { useNavigate } from "react-router-dom";

const clubPlanAPI = new ClubPlanAPI();
const clubSubscriptionAPI = new ClubSubscriptionAPI();

function ClubPlanListPage() {
    const [isLoading, setIsLoading] = useState(true);
    const [items, setItems] = useState([]);
    const [showModal, setShowModal] = useState(false);
    const [editingId, setEditingId] = useState(null);
    const [showModalSelectCustomers, setShowModalSelectCustomers] = useState(false);
    const [selectedPlanForCustomers, setSelectedPlanForCustomers] = useState(null);
    const navigate = useNavigate();

    const handleAddCustomers = (plan) => {
        setSelectedPlanForCustomers(plan);
        setShowModalSelectCustomers(true);
    };

    const handleViewCustomers = (plan) => {
       navigate(`/clubes/${plan?.id}/clientes`)
    };

    const handleConfirmCustomers = async (selectedCustomers) => {
        try {
            const clubPlanId = selectedPlanForCustomers?.id;

            const customerIds = selectedCustomers.map((c) => c.id);
            setIsLoading(true)
            await clubSubscriptionAPI.bulkCreate(clubPlanId,
                customerIds);
            HallAppToast.success();
            setShowModalSelectCustomers(false);
            setSelectedPlanForCustomers(null);
        } catch (e) {
            // deixa o modal tratar (como você já faz)
            throw e;
        } finally {
            setIsLoading(false)
        }
    };


    const load = async () => {
        try {
            setIsLoading(true);
            const res = await clubPlanAPI.list();
            const data = res?.data || res;
            const list = data?.items || data;
            setItems(Array.isArray(list) ? list : []);
        } catch (e) {
            setItems([]);
            HallAppToast.genericError();
        } finally {
            setIsLoading(false);
        }
    };

    useEffect(() => {
        load();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const openCreate = () => {
        setEditingId(null);
        setShowModal(true);
    };

    const openEdit = (id) => {
        setEditingId(id);
        setShowModal(true);
    };

    const closeModal = () => {
        setShowModal(false);
        setEditingId(null);
    };

    const toggleActive = async (p) => {
        try {
            setIsLoading(true);
            await clubPlanAPI.toggleActive(p.id);
            HallAppToast.success("Status atualizado com sucesso.");
            await load();
        } catch (e) {
            HallAppToast.genericError();
            setIsLoading(false);
        }
    };

    const remove = async (p) => {
        const ok = window.confirm(`Deseja realmente excluir o clube "${p?.name}"?`);
        if (!ok) return;

        try {
            setIsLoading(true);
            await clubPlanAPI.delete(p.id);
            HallAppToast.success("Clube excluído com sucesso.");
            await load();
        } catch (e) {
            HallAppToast.genericError();
            setIsLoading(false);
        }
    };

    return (
        <>
            <div className="container club-plan-page">
                <MenuTitle
                    title="Clubes de Assinatura"
                    subtitle="Crie e gerencie os planos do seu estabelecimento."
                    showArrowInfo={false}
                />

                {isLoading ? (
                    <AppLoading />
                ) : (
                    <Row className="g-3" style={{ margin: 0, width: "100%" }}>
                        {items.length === 0 ? (
                            <EmptyState
                                title="Nenhum clube criado"
                                description="Crie planos de assinatura para fidelizar seus clientes com benefícios exclusivos e cobranças recorrentes."
                                icon={<FontAwesomeIcon icon={faGem} />}
                                actionLabel="Criar meu primeiro clube"
                                onAction={openCreate}
                            />
                        ) : (
                            items.map((p) => (
                                <Col xs={12} sm={6} md={4} lg={4} key={p.id} className="mb-3">
                                    <ClubPlanCard
                                        plan={p}
                                        onEdit={() => openEdit(p.id)}
                                        onToggleActive={() => toggleActive(p)}
                                        onDelete={() => remove(p)}
                                        onAddCustomers={() => handleAddCustomers(p)}
                                        onViewCustomers={() => handleViewCustomers(p)}
                                    />
                                </Col>
                            ))
                        )}
                        {/* Espaçamento para o FloatingButton não cobrir o último card */}
                        <div style={{ height: "calc(50px + 72px)" }}></div>
                    </Row>
                )}
            </div>

            <FloatingButton
                icon={faAdd}
                onClick={openCreate}
            />

            {showModal && (
                <ModalClubConfiguration
                    show={showModal}
                    closeShow={closeModal}
                    clubPlanId={editingId}
                    onSuccess={() => load()}
                />
            )}

            {showModalSelectCustomers && (
                <ModalSelectCustomers
                    show={showModalSelectCustomers}
                    closeShow={() => {
                        setShowModalSelectCustomers(false);
                        setSelectedPlanForCustomers(null);
                    }}
                    multiple={true}
                    onConfirm={handleConfirmCustomers}
                    title={`Adicionar Clientes ao Clube: ${selectedPlanForCustomers?.name}`}
                    confirmLabel="Adicionar ao Clube"
                />
            )}
        </>
    );
}

export default ClubPlanListPage;